<template>
  <vue-tags-input
    v-model="input"
    placeholder="Add Struggle"
    :add-only-from-autocomplete="true"
    :autocomplete-items="filtered"
    :autocomplete-min-length="0"
    :tags="value"
    @tags-changed="(tags) => $emit('input', tags)"
  />
</template>

<script>
import UserClient from '@/api/UserClient';
import VueTagsInput from '@johmun/vue-tags-input';
import { tagFromName } from '@/helpers/tags';

export default {
  name: 'StrugglePicker',

  components: {
    VueTagsInput
  },

  props: {
    value: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      userClient: new UserClient(this.$http),

      input: '',
      choices: []
    };
  },

  computed: {
    filtered() {
      return this.choices.filter(
        (c) => c.text.toLowerCase().indexOf(this.input.toLowerCase()) !== -1
      );
    }
  },

  async mounted() {
    const specialties = await this.userClient.getSpecialtiesList('', 500);
    this.choices = (specialties.results || []).map(tagFromName);
  }
};
</script>
